import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fullscreenLoading:true,
    neddloding:0,
  	pageViewHeigh:600,
    token:"",
    enterpriseAuthe:{
      steps_active:0
    },
    userInfo:{}
  },
  mutations: {
    gbfullscreenLoading(state){
      state.fullscreenLoading=true;//loading显示
    },
    gbfullscreenLoadinga(state){
      state.fullscreenLoading=false;//loading关闭
    },
    show(state){//每请求一次加一
      state.neddloding++
    },
    hide(state){//每完成请求一次减一
      state.neddloding--
    },
  	SET_PAGE_VIEW_HEIGH(state,param){
  		state.pageViewHeigh= param.height;
  	},
    SET_TOKEN(state,token){
			state.token = token;
    },
    SET_USERINFO(state,userInfo){
      state.userInfo = userInfo
    },
    SET_EnterpriseAuthe(state,param){
      state.enterpriseAuthe[param.key] = param.value
    }
  },
  getters:{
    getUserInfo:function(){
      return;
    }
  },
  actions: {
  },
  modules: {
  }
})
